import React, { useEffect } from "react";
import { any, func, number, object, oneOfType, shape } from "prop-types";
import Form from "@insightfulscience/atomic-react/Form";
import { idX } from "@insightfulscience/shared-utils/fn";
import FormContext from "./context";
import Field from "./Field";
import useSmartForm from "./hook";
import ValueOf from "./ValueOf";
import useWatch from "./useWatch";
import { setRef } from "../events/handlers";

function SmartForm({
	initialState,
	validateForm,
	action,
	textRender = idX,
	onTouched,
	onChange,
	stateRef,
	apiRef,
	blurDelay,
	...props
}) {
	const formData = useSmartForm(initialState, validateForm, action, stateRef, { blurDelay });

	setRef(apiRef, formData);

	useWatch(
		formData.touched.length, // watch for changes
		onTouched,
		(next, prev) => next > prev,
	);

	useEffect(
		() =>
			typeof onChange === "function" && formData.touched.length > 0
				? onChange(formData.form)
				: undefined,
		[formData.form], // dpes
	);

	return (
		<FormContext.Provider value={{ ...formData, textRender }}>
			<Form {...props} onSubmit={formData.submit} noValidate />
		</FormContext.Provider>
	);
}

SmartForm.propTypes = {
	initialState: object, // eslint-disable-line react/forbid-prop-types
	validateForm: func,
	action: func,
	textRender: func,
	onTouched: func,
	onChange: func,
	stateRef: oneOfType([func, shape({ current: any })]), // eslint-disable-line react/forbid-prop-types
	apiRef: oneOfType([func, shape({ current: any })]), // eslint-disable-line react/forbid-prop-types
	blurDelay: number,
};

SmartForm.Field = Field;
SmartForm.ValueOf = ValueOf;
SmartForm.context = FormContext;

export { Field, ValueOf, FormContext };

export default SmartForm;
